import { ApplicationConfig, mergeConfigs } from '../interface/response/ApplicationConfig';
import { getConfigFromLocalStorage, setConfigToLocalStorage } from './local-storage';
import { AppDispatch } from '../store/store';
import { updateConfig } from '../store/slice/config/config';

export async function updateApplicationConfig(config: ApplicationConfig, dispatch: AppDispatch) {
  try {
    const localConfig = getConfigFromLocalStorage();
    if (localConfig) {
      const updatedConfig = mergeConfigs(localConfig, config);
      await dispatch(updateConfig(updatedConfig));
    } else {
      throw new Error();
    }
  } catch (error) {
    const localConfig = getConfigFromLocalStorage();
    const mergedConfig = mergeConfigs(localConfig || {}, config);
    setConfigToLocalStorage(mergedConfig);
  }
}
